import { FC, ReactNode } from 'react'
import { FormControl, MenuItem, Box } from '@material-ui/core'
import { StyledLabel } from '../../atoms/styled'
import { SelectInputProps } from '@material-ui/core/Select/SelectInput'
import styled from 'styled-components'
import { StyledSelect } from 'pages/profile/components/edit-member-profile/EditProfilePage'
import { KeyboardArrowDown } from '@material-ui/icons'
import { darken } from 'polished'

interface ISelectProps extends SelectInputProps {
  menuItemList: any[]
  theme: any
  width?: string
  label?: string | ReactNode
  placeholder?: string
  defaultValue?: string | number
  style?: any
  id?: string
}

const StyledFormControl = styled(FormControl) <{ width?: string }>`
  max-width: ${props => props.width ?? '5.4rem'};
  width: 100%;
`

export const OldSelect: FC<ISelectProps> = props => {
  const { menuItemList, theme, width, label, placeholder, defaultValue, style, id, ...rest } = props

  const selectDefaultValue = () => {
    if (defaultValue) {
      return defaultValue
    } else if (placeholder) {
      return placeholder
    } else return 'none'
  }

  return (
    <StyledFormControl width={width} style={style}>
      <StyledLabel>{label}</StyledLabel>
      <StyledSelect
        disableUnderline
        displayEmpty
        IconComponent={props => (
          <KeyboardArrowDown {...props} style={{ color: theme.colors.primary, marginRight: '6px' }} />
        )}
        {...rest}
        defaultValue={selectDefaultValue()}
        MenuProps={{
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left'
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left'
          },
          getContentAnchorEl: null,
          style: {
            width: '170px'
          }
        }}
      >
        {placeholder && (
          <MenuItem disabled value="">
            <Box color={darken(0.2, theme.colors.accent)}>{placeholder}</Box>
          </MenuItem>
        )}
        {menuItemList.map(menuItem => (
          <MenuItem value={menuItem.value}>{menuItem.label}</MenuItem>
        ))}
      </StyledSelect>
    </StyledFormControl>
  )
}
